import React, { useState } from "react";

const FooterNewsletter = ({ onSubmit }) => {
  const [email, setEmail] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    if (email.trim() === "") return;

    onSubmit(email);
    setEmail("");
  };

  return (
    <>
      <h4>Our Newsletter</h4>
      <p>
        Revolutionizing the Future: Your Update on Smart Industry Insights
      </p>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          required
        />
        <input type="submit" value="Subscribe" />
      </form>
    </>
  );
};

export default FooterNewsletter;
